import React from "react";
import { Navigate } from "react-router-dom";
export default function EditProfile(props: any) { return props.showDialog ? <Navigate to="/account" replace /> : null; }
